import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=9821b0a4&"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports